// src/theme.js — OverPower.TV v2.0
// Tokens de docs/IDENTIDAD_VISUAL.md — regla 90/8/2: 90% neutros, 8% violeta, 2% "en vivo".
import { createTheme } from "@mui/material/styles";

export const op = {
  bg: { base: "#0A0A12", surface: "#14141F", elevated: "#1E1B2E" },
  violet: { main: "#9D00FF", text: "#C77DFF", deep: "#6A00CC" },
  live: "#00E5FF", // solo "en vivo" / tiempo real
  border: "rgba(237,233,247,0.08)", // borde neutro por defecto
  gradient: "linear-gradient(135deg, #9D00FF 0%, #6A00CC 100%)",
  glow: {
    interactive: "0 0 12px rgba(157,0,255,.4)",
    hero: "0 0 32px rgba(157,0,255,.45), 0 0 72px rgba(157,0,255,.18)",
  },
};

const theme = createTheme({
  palette: {
    mode: "dark",
    background: { default: op.bg.base, paper: op.bg.surface },
    primary: {
      main: op.violet.main, // gráfico y display grande (AA large)
      light: op.violet.text, // texto violeta legible — 7.33:1
      dark: op.violet.deep, // fondo de botón — blanco encima 8.45:1
      contrastText: "#FFFFFF",
    },
    info: { main: op.live, contrastText: "#0A0A12" }, // "en vivo" — 12.82:1
    success: { main: "#00E08F", contrastText: "#0A0A12" }, // 11.32:1
    warning: { main: "#FFD60A", contrastText: "#0A0A12" }, // 13.97:1
    error: { main: "#FF5C5C", contrastText: "#0A0A12" }, // 6.51:1
    text: { primary: "#EDE9F7", secondary: "#A8A3B8", disabled: "#6E6880" },
    divider: op.border,
  },
  typography: {
    fontFamily: "'Inter', 'Segoe UI', sans-serif",
    h1: { fontFamily: "'Space Grotesk', sans-serif", fontWeight: 700, fontSize: "2.5rem", lineHeight: 1.1, letterSpacing: "-0.02em" },
    h2: { fontFamily: "'Space Grotesk', sans-serif", fontWeight: 700, fontSize: "1.75rem", lineHeight: 1.2, letterSpacing: "-0.01em" },
    h3: { fontFamily: "'Space Grotesk', sans-serif", fontWeight: 500, fontSize: "1.375rem", lineHeight: 1.3 },
    h4: { fontWeight: 600, fontSize: "1.125rem", lineHeight: 1.35 },
    body1: { fontSize: "1rem", lineHeight: 1.6 },
    body2: { fontSize: "0.875rem", lineHeight: 1.5 },
    overline: { fontSize: "0.75rem", fontWeight: 600, letterSpacing: "0.08em", textTransform: "uppercase" },
    button: { fontWeight: 600, fontSize: "0.9375rem", textTransform: "none" },
  },
  shape: { borderRadius: 10 },
  spacing: 8,
  shadows: [
    "none",
    "0 1px 3px rgba(0,0,0,.5)", // 1: reposo
    "0 4px 16px rgba(0,0,0,.45)", // 2: elevación (modales, dropdowns)
    op.glow.interactive, // 3: hover/focus/activo
    op.glow.hero, // 4: hero — máx. uno por página
    ...Array(20).fill("0 4px 16px rgba(0,0,0,.45)"),
  ],
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: op.bg.surface,
          border: `1px solid ${op.border}`, // neutro en reposo
          boxShadow: "none",
          backgroundImage: "none",
          transition: "border-color 150ms ease-out, transform 150ms ease-out",
          "&:hover": {
            borderColor: "rgba(157,0,255,.6)", // violeta solo al interactuar
            transform: "translateY(-2px)",
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          backgroundColor: op.violet.deep,
          "&:hover": { backgroundColor: op.violet.main, boxShadow: op.glow.interactive },
        },
        outlinedPrimary: {
          borderColor: op.border,
          color: "#EDE9F7",
          "&:hover": { borderColor: op.violet.text, backgroundColor: "rgba(157,0,255,.08)" },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { backgroundColor: op.bg.elevated, color: "#EDE9F7", fontWeight: 600 },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: { color: op.violet.text, textDecorationColor: "rgba(199,125,255,.4)" },
      },
    },
  },
});

export default theme;
